import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-boite-aide',
  templateUrl: './boite-aide.component.html',
  standalone: false
})
export class BoiteAideComponent {
  @Output()
  clickToCall = new EventEmitter();
}
